import { SB } from '@play-co/replicant';

export const conversationSchema = {
  conversation: SB.object({
    dialogs: SB.map(
      SB.object({
        timesSeen: SB.number(),
      }),
    ),
    answers: SB.map(
      SB.object({
        key: SB.string().optional(),
        value: SB.string(),
      }),
    ),
  }),
};
